import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import PercentageStackedBarChart from '../chartjs/PercentageStackedBarChart.vue';
import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import { ReportType } from '../../models/reportType';
import { useFlowReport } from '@/features/reports/components/flows/useFlowReport';
import { watch } from 'vue';
import Report from '@/features/reports/components/Report.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowEngagementCharts',
  emits: ["loaded"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const {
  reportId,
  isDataLoaded,
  isDataEmpty,
  loadingError,
  data,
  showLineChart,
  showPercentageBarChart,
  showBarChart,
  switchLineChart,
  switchStackedChart,
  switchBarChart,
} = useFlowReport(ReportType.FLOW_ENGAGEMENT);

watch([isDataLoaded, loadingError], () => {
  if (isDataLoaded.value) emit('loaded');
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: "Engagement Trend",
    "tooltip-text": "A trend showing the proportion of users who started a flow and subsequently engaged and completed the flow",
    class: "chart-container",
    dataEmpty: _unref(isDataEmpty),
    loadedData: _unref(isDataLoaded),
    loadingError: _unref(loadingError)
  }, {
    "header-addons": _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["button", { 'is-static': _unref(showLineChart) }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(switchLineChart)()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chart-line" })
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["button percent-button", { 'is-static': _unref(showPercentageBarChart) }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(switchStackedChart)()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "percent" })
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["button", { 'is-static': _unref(showBarChart) }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(switchBarChart)()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chart-bar" })
      ], 2)
    ]),
    chart: _withCtx(() => [
      (_unref(showLineChart))
        ? (_openBlock(), _createBlock(LineChart, {
            key: 0,
            reportId: _unref(reportId),
            class: "chart",
            data: _unref(data),
            fill: true,
            seriesOrder: ['Started', 'Engaged', 'Completed']
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true),
      (_unref(showPercentageBarChart))
        ? (_openBlock(), _createBlock(PercentageStackedBarChart, {
            key: 1,
            reportId: _unref(reportId),
            class: "chart",
            data: _unref(data),
            seriesOrder: ['Started', 'Engaged', 'Completed'],
            "series-to-compare-to": "Started"
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true),
      (_unref(showBarChart))
        ? (_openBlock(), _createBlock(BarChart, {
            key: 2,
            reportId: _unref(reportId),
            class: "chart",
            data: _unref(data),
            seriesOrder: ['Started', 'Engaged', 'Completed']
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["report-id", "dataEmpty", "loadedData", "loadingError"]))
}
}

})